import React from 'react';
import {
  compose,
  setDisplayName,
  withProps,
  defaultProps,
} from 'recompose';
import reactCSS from 'reactcss';
import CookieToggle from '../cookie-toggle';
import { getStyles } from '@ux/style-utils';
import stylesheet from './CookieToggleGroup.stylesheet';

const stylesheetToStyles = (stylesheet, props) => reactCSS(stylesheet, {
  tablet: props.isMinSm || props.isMinMd,
  desktop: props.isMinLg,
  xsCols: props.xsCols,
  smCols: props.smCols,
  lgCols: props.lgCols,
});

export const PureCookieToggleGroup = ({
  theme,
  cookies,
  styles,
}) => (
  <div style={styles.root}>
    <div style={styles.row}>
      <For
        each="cookie"
        of={cookies}
      >
        <div
          key={cookie.name}
          style={styles.item}
        >
          <CookieToggle
            theme={theme}
            name={cookie.name}
            canOptOut={cookie.optOut}
          />
        </div>
      </For>
    </div>
  </div>
);

export const enhance = compose(
  setDisplayName('CookieToggleGroup'),
  defaultProps({
    xsCols: 12,
    mdCols: 6,
    lgCols: 3,
  }),
  withProps((ownerProps) => ({
    styles: getStyles(stylesheet, stylesheetToStyles, ownerProps),
  })),
);

export default enhance(PureCookieToggleGroup);
